// ImageGrid: the thumbnail grid for pickers inside modals. Columns are as wide as `minWidth` allows, but never fewer than two,
// so a phone-width modal shows two images per row instead of one big one. Props: minWidth (140), gap (8, in px), sx, and any Box props.
(function () {
  const { Box } = MaterialUI;

  function ImageGrid({ minWidth = 140, gap = 8, sx, children, ...props }) {
    return (
      <Box
        {...props}
        sx={[{ display: 'grid', gridTemplateColumns: `repeat(auto-fill, minmax(min(${minWidth}px, calc(50% - ${gap / 2}px)), 1fr))`, gap: `${gap}px` }, ...(Array.isArray(sx) ? sx : [sx])]}
      >
        {children}
      </Box>
    );
  }

  window.Components = window.Components || {};
  window.Components.ImageGrid = ImageGrid;
})();
